import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import { GetWalletsPayload, WalletsResponse, WalletState } from '../models'

import { WALLET } from './api.routes'
import { WalletActions } from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllWalletThunk = createAsyncThunk(
  ActionTypes.GET_ALL_WALLET,
  async (payload: GetWalletsPayload, thunkAPI) => {
    try {
      const { xlsx, ...queries } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(WalletActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.requestParams = {
        method: 'GET',
        endpoint: WALLET.FIND_ALL,
        queries: jsonToQueryString(queries),
      }

      const response: WalletsResponse = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : response.message && response.message.length > 0
            ? response.message[0]
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({ message: error, status: error })
    }
  },
)

const getAllWalletExtraReducer = (
  builder: ActionReducerMapBuilder<WalletState>,
) => {
  builder.addCase(getAllWalletThunk.fulfilled, (state, { payload, meta }) => {
    const { xlsx } = meta?.arg

    state.isLoading = false
    state.wallets = xlsx ? state.wallets : payload.docs
    state.pagination = xlsx
      ? state.pagination
      : {
          ...state.pagination,
          total: payload.total,
          pages: payload.pages,
          page: payload.page,
          limit: payload.limit,
        }
  })
  builder.addCase(getAllWalletThunk.rejected, (state) => {
    state.isLoading = false
  })
}

export default getAllWalletExtraReducer
